document.addEventListener('DOMContentLoaded', function () {

  async function addWishlistProductInfo() {

    const cards = document.querySelectorAll(
      '.wishlist-hero-list-card-header'
    );

    for (const card of cards) {

      // If already successfully inserted, skip
      if (card.querySelector('.wishlist-product-sku')) {
        continue;
      }

      const productLink = card.querySelector(
        '.wishlist-hero-list-card-header-product-name'
      );

      if (!productLink) {
        continue;
      }

      const href = productLink.getAttribute('href');

      if (!href || !href.includes('/products/')) {
        continue;
      }

      try {

        const url = new URL(
          href,
          window.location.origin
        );

        const productUrl = url.pathname;
        const variantId = url.searchParams.get('variant');


        /* =========================
           1. GET SKU
        ========================= */

        const productResponse = await fetch(
          productUrl + '.js'
        );

        if (!productResponse.ok) {
          continue;
        }

        const product = await productResponse.json();

        if (
          !product.variants ||
          !product.variants.length
        ) {
          continue;
        }

        let variant = null;

        // Try exact Wishlist variant first
        if (variantId) {

          variant = product.variants.find(function (v) {
            return String(v.id) === String(variantId);
          });

        }

        // Fallback to first variant
        if (!variant) {
          variant = product.variants[0];
        }

        if (!variant || !variant.sku) {
          continue;
        }

        const sku = variant.sku;
        const isAvailable = variant.available;


        /* =========================
           2. GET COLLECTION
           Optional only
        ========================= */

        let collectionName = '';
        let collectionUrl = '';

        try {

          const pageResponse = await fetch(productUrl);

          if (pageResponse.ok) {

            const html = await pageResponse.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(
              html,
              'text/html'
            );

            const collectionLink = doc.querySelector(
              '.sku-text a[href*="/collections/"]'
            );

            if (collectionLink) {

              collectionName =
                collectionLink.textContent.trim();

              collectionUrl =
                collectionLink.getAttribute('href');

            }

          }

        } catch (collectionError) {

          console.warn(
            'Wishlist collection not found:',
            productUrl
          );

        }


        /* =========================
           3. INSERT INTO WISHLIST
        ========================= */

        const content = card.querySelector(
          '.MuiCardHeader-content'
        );

        if (!content) {
          continue;
        }

        // Prevent duplicate insertion
        if (card.querySelector('.wishlist-product-sku')) {
          continue;
        }

        const infoElement =
          document.createElement('div');

        infoElement.className =
          'wishlist-product-sku';


        /* Collection */
        if (collectionName && collectionUrl) {

          const collectionElement =
            document.createElement('a');

          collectionElement.href =
            collectionUrl;

          collectionElement.textContent =
            collectionName;

          collectionElement.className =
            'wishlist-product-collection';

          infoElement.appendChild(
            collectionElement
          );

          infoElement.appendChild(
            document.createTextNode(' : ')
          );

        }


        /* SKU */
        const skuElement =
          document.createElement('span');

        skuElement.textContent = sku;

        infoElement.appendChild(
          skuElement
        );


        /* Insert */
        content.prepend(
          infoElement
        );

        /* =========================
   STOCK STATUS
========================= */

const footer = card.querySelector(
  '.wishlist-hero-list-card-footer'
);

const addToCartButton = card.querySelector(
  '.wishlist-hero-list-card-footer-add-to-cart'
);

if (footer && addToCartButton && !isAvailable) {

  addToCartButton.textContent = 'OUT OF STOCK';
  addToCartButton.disabled = true;

  const buttonGroup = footer.querySelector('[role="group"]');

  if (
    buttonGroup &&
    !buttonGroup.querySelector('.wishlist-notify-me')
  ) {

    const notifyButton = document.createElement('button');

    notifyButton.type = 'button';
    notifyButton.className = 'wishlist-notify-me';
    notifyButton.textContent = 'Notify Me';

    notifyButton.addEventListener('click', function () {

      window.location.href =
        productUrl +
        '?variant=' +
        variant.id +
        '&notify_me=1';

    });

    addToCartButton.insertAdjacentElement(
      'afterend',
      notifyButton
    );
  }
}
        // Only mark after actual success
        card.dataset.skuAdded = 'true';


      } catch (error) {

        console.error(
          'Wishlist SKU error:',
          error
        );

        delete card.dataset.skuAdded;

      }

    }

  }


  /* Initial load */
  addWishlistProductInfo();


  /* Wishlist Hero loads dynamically */
  let wishlistTimer;

  const observer =
    new MutationObserver(function () {

      clearTimeout(wishlistTimer);

      wishlistTimer = setTimeout(function () {
        addWishlistProductInfo();
      }, 50);

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );



  /* =====================================
   WISHLIST ADDED NOTIFICATION
   Collection + SKU + Price
   ===================================== */

(function () {

  const processedNotifications = new WeakSet();

  async function customizeWishlistNotification() {

    const notification = document.querySelector(
      '#wishlist-hero-add-prod-to-wishlist-notification'
    );

    if (!notification || processedNotifications.has(notification)) {
      return;
    }

    const card = notification.querySelector('.MuiCard-root');

    if (!card) {
      return;
    }

    /* Find product link inside notification */
    const productLink = card.querySelector('a[href*="/products/"]');

    if (!productLink) {
      return;
    }

    const href = productLink.getAttribute('href');

    if (!href) {
      return;
    }

    try {

      const url = new URL(
        href,
        window.location.origin
      );

      const productUrl = url.pathname;
      const variantId = url.searchParams.get('variant');


      /* =========================
         GET PRODUCT DATA
         ========================= */

      const productResponse = await fetch(
        productUrl + '.js'
      );

      if (!productResponse.ok) {
        return;
      }

      const product = await productResponse.json();

      if (!product.variants || !product.variants.length) {
        return;
      }

      let variant = null;

      if (variantId) {
        variant = product.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
      }

      if (!variant) {
        variant = product.variants[0];
      }


      /* =========================
         GET COLLECTION
         ========================= */

      let collectionName = '';
      let collectionUrl = '';

      try {

        const pageResponse = await fetch(productUrl);

        if (pageResponse.ok) {

          const html = await pageResponse.text();

          const parser = new DOMParser();

          const doc = parser.parseFromString(
            html,
            'text/html'
          );

          const collectionLink = doc.querySelector(
            '.sku-text a[href*="/collections/"]'
          );

          if (collectionLink) {

            collectionName =
              collectionLink.textContent.trim();

            collectionUrl =
              collectionLink.getAttribute('href');
          }
        }

      } catch (error) {

        console.warn(
          'Wishlist notification collection error:',
          error
        );

      }


      /* =========================
         FIND CONTENT AREA
         ========================= */

      const content = card.querySelector(
        '.MuiCardContent-root'
      );

      if (!content) {
        return;
      }


      /* =========================
         COLLECTION + SKU
         ========================= */

      if (!content.querySelector('.wishlist-notification-product-info')) {

        const productInfo =
          document.createElement('div');

        productInfo.className =
          'wishlist-notification-product-info';


        /* Collection */
        if (collectionName) {

          if (collectionUrl) {

            const collection =
              document.createElement('a');

            collection.href = collectionUrl;

            collection.className =
              'wishlist-notification-collection';

            collection.textContent =
              collectionName;

            productInfo.appendChild(collection);

          } else {

            const collection =
              document.createElement('span');

            collection.className =
              'wishlist-notification-collection';

            collection.textContent =
              collectionName;

            productInfo.appendChild(collection);
          }


          /* Separator */
          if (variant && variant.sku) {
            productInfo.appendChild(
              document.createTextNode(' : ')
            );
          }
        }


        /* SKU */
        if (variant && variant.sku) {

          const sku =
            document.createElement('span');

          sku.className =
            'wishlist-notification-sku';

          sku.textContent =
            variant.sku;

          productInfo.appendChild(sku);
        }


        content.prepend(productInfo);
      }


      /* =========================
         PRICE
         ========================= */

      if (
        variant &&
        variant.price != null &&
        !content.querySelector('.wishlist-notification-price')
      ) {

        const price =
          document.createElement('div');

        price.className =
          'wishlist-notification-price';

        price.textContent =
          Shopify.formatMoney
            ? Shopify.formatMoney(variant.price)
            : '$' + (variant.price / 100).toFixed(2);

        content.appendChild(price);
      }


      processedNotifications.add(notification);

      /* Show customized notification only when ready */
      requestAnimationFrame(function () {
        notification.classList.add('wishlist-notification-ready');
      });


    } catch (error) {

      console.error(
        'Wishlist notification error:',
        error
      );

    }

  }


  /* Wishlist notification is dynamically created */

  
  const wishlistNotificationObserver =
    new MutationObserver(function () {

      customizeWishlistNotification();

    });


  wishlistNotificationObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  customizeWishlistNotification();

})();

});

